export interface FlyerSources {
  /** 600px-wide rendering — enough for phone-width teasers. */
  src600: string;
  /** 1200px-wide rendering — retina teasers and the enlarge dialog. */
  src1200: string;
}

const OPENAIR_KINO_2026: FlyerSources = {
  src600: "/flyer/openair-kinderkino-2026-600.png",
  src1200: "/flyer/openair-kinderkino-2026-1200.png",
};

// eventId → artwork/documents, deliberately a frontend-only map instead of
// fields on the Event schema: adding next year's assets is files under
// public/ plus one entry here, with no shared-schema / backend / admin churn.
// Unknown eventId → nulls → the page renders without a flyer or AGB link,
// exactly as it did before these assets existed.
interface EventAssets {
  flyer: FlyerSources | null;
  /**
   * Versioned AGB PDF, generated by `pnpm generate-agb <eventId>` from
   * scripts/agb/<eventId>.ts. The delivery email links the same file by the
   * /agb/agb-<eventId>.pdf convention ("agb-" prefix so the downloaded file
   * is recognizable) — keep the path shape in sync with backend tickets.ts.
   */
  agbPdf: string | null;
}

const OPENAIR_KINO_2026_ASSETS: EventAssets = {
  flyer: OPENAIR_KINO_2026,
  agbPdf: "/agb/agb-openair-kinderkino-2026.pdf",
};

const EVENTS: Readonly<Record<string, EventAssets>> = {
  "openair-kinderkino-2026": OPENAIR_KINO_2026_ASSETS,
  // Local dev seed (DEFAULT_SEED in scripts/seed-event.ts) — same assets so
  // `pnpm dev:buy` renders the real page.
  "openair-kino-sample": OPENAIR_KINO_2026_ASSETS,
};

export function flyerFor(eventId: string): FlyerSources | null {
  return EVENTS[eventId]?.flyer ?? null;
}

export function agbPdfFor(eventId: string): string | null {
  return EVENTS[eventId]?.agbPdf ?? null;
}
